import React, { useState } from "react";
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button, Input, Row, Col,
  NavLink
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";
import { reloadWindowToPath } from "../../Helpers/Utils";

const StockBulkImportModal = ({ open, toggle, onSuccess }) => {

  const dispatch = useDispatch();
  const user = useSelector(s => s.customer.customer);
  const loading = useSelector(s => s.loading.loading);

  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);

  /* ================= UPLOAD CSV ================= */
  const uploadCSV = async () => {

    if (!file) return toast.error("CSV file required");

    dispatch(loadingTrue());

    const formData = new FormData();
    formData.append("file", file);
    formData.append("outlet_id", user?.outlet_id);

    try {
      const res = await Handler({
        method: "post",
        url: "/inventory/bulk_update_stock.php",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" }
      });

      if (res?.success) {
        toast.success("Stock import completed");
        setResult(res.data);
        reloadWindowToPath('/products')
        onSuccess && onSuccess();
      } else {
        toast.error(res?.message || "Stock import failed");
      }

    } catch {
      toast.error("Network error");
    }

    dispatch(loadingFalse());
  };

  return (
    <Modal isOpen={open} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>
        Stock Bulk Import
      </ModalHeader>

      <ModalBody>
        <div className="d-flex justify-content-center">
          <NavLink
            to="#"
            onClick={(e) => { e.preventDefault(); const link = document.createElement("a"); link.href = "/stock-import.csv"; link.download = "product-import.csv"; document.body.appendChild(link); link.click(); document.body.removeChild(link); }} className="menu-item mb-4 sample-btn"
          >
            <i className="bx bx-download me-2"></i> Download Sample CSV
          </NavLink>
        </div>

        {/* FILE INPUT */}
        <Row className="mb-3">
          <Col md={12}>
            <label className="fw-semibold mb-1">Upload Stock CSV</label>
            <Input
              type="file"
              accept=".csv"
              onChange={e => setFile(e.target.files[0])}
            />
            <small className="text-muted">
              Columns: product_id | variant_id (optional) | quantity | note
            </small>
          </Col>
        </Row>

        {/* RESULT SUMMARY */}
        {result && (
          <div className="border rounded p-3 bg-light mt-3">

            <Row className="mb-2">
              <Col md={4}>
                <b>Rows Processed</b>
                <div className="text-info fs-5">
                  {result.processed}
                </div>
              </Col>

              <Col md={4}>
                <b>Stock Added</b>
                <div className="text-success fs-5">
                  {result.success}
                </div>
              </Col>

              <Col md={4}>
                <b>Failed</b>
                <div className="text-danger fs-5">
                  {result.failed}
                </div>
              </Col>
            </Row>

            {/* ERROR LIST */}
            {result.errors && result.errors.length > 0 && (
              <div className="mt-3">
                <b className="text-danger">Errors</b>
                <ul className="small text-danger mt-1">
                  {result.errors.map((e, i) => (
                    <li key={i}>{e}</li>
                  ))}
                </ul>
              </div>
            )}

          </div>
        )}

      </ModalBody>

      <ModalFooter>
        <Button disabled={loading} color="light" onClick={toggle}>
          Cancel
        </Button>
        <Button disabled={loading} className="add-btn" onClick={uploadCSV}>
          Upload Stock
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default StockBulkImportModal;
